import { MESSAGES } from '../utils/constants'
import { MIDDLELAYER_API, SYNDEO_API } from '../utils/constants/endpoints'
import { getLocalState } from '../utils/local-storage'
import { emailRegex } from '../utils/regex'
import { ITokenType } from '../utils/types/common'
import {
    SyndeoBoosterResponse,
    SyndeoReportResponse,
    TreatmentReportResponse,
} from '../utils/types/dashboard'
import { Axios } from './axios'

export const getAllTreatments = async (
    startDate?: number,
    endDate?: number
) => {
    try {
        const response = await Axios.syndeoInstance.get<
            TreatmentReportResponse[]
        >(`${SYNDEO_API.MY_REPORT_TREATMENT_DATA}`, {
            params: {
                startDate,
                endDate,
            },
        })
        if (response.data) return response.data
        else throw new Error(MESSAGES.error.endpointError)
    } catch (error) {
        throw Error(MESSAGES.error.failedTo('Dashboard'))
    }
}

export const getAllSyndeoReports = async (
    startDate?: number,
    endDate?: number
) => {
    try {
        const response = await Axios.syndeoInstance.get<SyndeoReportResponse>(
            `${SYNDEO_API.MY_REPORT_TREATMENT}`,
            {
                params: {
                    startDate,
                    endDate,
                },
            }
        )
        if (response.data) return response.data
        else throw new Error(MESSAGES.error.endpointError)
    } catch (error) {
        throw Error(MESSAGES.error.failedTo('Dashboard'))
    }
}
/**
 * getBoosterReports
 * @desc fetch the booster reports
 * @method {GET}
 * @param {number} [startDate=] `startDate` is the unix format for date where the resports start from
 * @param {number} [endDate=] `endDate` is the unix format of the reports end date
 * @returns {Promise<SyndeoBoosterResponse>}
 */
export const getBoosterReports = async (
    startDate?: number,
    endDate?: number
): Promise<SyndeoBoosterResponse> => {
    const response = await Axios.syndeoInstance.get<SyndeoBoosterResponse>(
        `${SYNDEO_API.SYNDEO_BOOSTER}`,
        {
            params: {
                startDate,
                endDate,
            },
        }
    )
    if (!response.data) {
        throw new Error(MESSAGES.error.endpointError)
    }
    return response.data
}

export const getClientInformation = async (searchQuery: string) => {
    const isEmail = emailRegex.test(searchQuery)
    const searchTerm = isEmail
        ? searchQuery
        : `+1${searchQuery}`.replace(/[-.\s()]/g, '')
    const data = {
        clientLookup: {
            searchTerm,
            isEmail,
        },
    }

    try {
        const response = await Axios.middleLayerInstance.post(
            MIDDLELAYER_API.CLIENT_LOOKUP,
            data
        )
        return response
    } catch (error: any) {
        return error.response.data
    }
}

export const getRewardHistory = async (id: string) => {
    const data = {
        rewardsHistoryRequestDto: {
            requestType: '',
            lastSyncDate: '',
            customerIds: id,
            lastCustomerId: '',
            limit: '',
        },
    }
    try {
        const response = await Axios.middleLayerInstance.post(
            MIDDLELAYER_API.REWARD_HISTORY,
            data
        )
        if (response.data) {
            if (response.data) return response.data
        }
    } catch (error) {
        console.log(error)
    }
}

export const handleb2b2cOptIn = async (
    action: string,
    isMultiAccount?: boolean
) => {
    const isOptIn = action === 'optIn'
    const requestURL = isOptIn
        ? MIDDLELAYER_API.LOYALTY_OPT_IN
        : MIDDLELAYER_API.LOYALTY_OPT_OUT
    const requestDto = isOptIn
        ? isMultiAccount
            ? {
                  loyaltyOptInRequestDto: {
                      optInConsumer: false,
                      optInProvider: true,
                      optInConsumerRedemption: true,
                      mlpOptIn: isMultiAccount,
                  },
              }
            : {
                  loyaltyOptInRequestDto: {
                      optInConsumer: false,
                      optInProvider: true,
                      optInConsumerRedemption: true,
                  },
              }
        : {
              loyaltyOptOutRequestDto: {
                  optInConsumer: false,
                  optInProvider: true,
                  optInConsumerRedemption: false,
              },
          }

    const data = {
        ...requestDto,
    }
    try {
        const response: any = await Axios.middleLayerInstance.post(
            requestURL,
            data
        )
        if (response) {
            return response
        }
    } catch (error) {
        console.log(error)
    }
}

export const sendInvitation = async (searchTerm: string) => {
    if (!emailRegex.test(searchTerm)) {
        return true
    }

    const data = {
        sendInvitationConsumerDto: {
            emailAddress: searchTerm,
            mobilePhoneNumber: null,
        },
    }
    try {
        const response: any = await Axios.middleLayerInstance.post(
            MIDDLELAYER_API.SEND_CONSUMER_INVITATION,
            data
        )
        if (response) {
            return response
        }
    } catch (error) {
        console.log(error)
    }
}
export const sendEstiInvitation = async (searchTerm: string) => {
    if (!emailRegex.test(searchTerm)) {
        return
    }

    const data = {
        estiInvitationDto: {
            emailAddress: searchTerm,
        },
    }
    try {
        const response: any = await Axios.middleLayerInstance.post(
            MIDDLELAYER_API.SEND_ESTI_INVITATION,
            data
        )
        if (response) return response
    } catch (error: any) {
        throw new Error(error.response.data.message ?? error)
    }
}

export const handleRedeemPoints = async (redemptionData: any) => {
    const tokens = getLocalState('auth-token') as ITokenType
    const data = {
        requestFor: 'create-treatment-history',
        accessToken: tokens.jwtToken,
        appUserKey: redemptionData?.providerId,
        createTreatmentHistoryDto: {
            includedTips: 'Test',
            ...redemptionData,
        },
    }
    try {
        const response = await Axios.middleLayerInstance.post(
            MIDDLELAYER_API.CREATE_TREATMENT_HISTORY,
            data
        )
        if (response.data) {
            return response.data
        }
    } catch (error) {
        console.log(error)
    }
}
